import { render, staticRenderFns } from "./OwnerReports.vue?vue&type=template&id=38e2fafa&"
import script from "./OwnerReports.vue?vue&type=script&lang=ts&"
export * from "./OwnerReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports